module.exports = __webpack_public_path__ + "img/rs.5508bcdd.svg";